import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { to: "/", label: "Accueil" },
    { to: "/carte", label: "La carte" },
    { to: "/commander", label: "Commander" },
    { to: "/boutiques", label: "Boutiques" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header className="sticky top-0 z-40">
            <div className="bg-[#FFF1E0] border-b-2 border-[#2A1408]">
                <div className="max-w-6xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
                    <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3">
                        <img
                            src="/brand/logo.png"
                            alt="Le Comptoir du Cookie"
                            className="h-14 w-auto"
                        />
                    </Link>

                    <nav className="hidden md:flex items-center gap-2">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
                                className={({ isActive }) =>
                                    `px-4 py-2 rounded-full text-sm font-bold transition-all ${
                                        isActive
                                            ? "bg-[#2A1408] text-[#FFF1E0]"
                                            : "text-[#2A1408] hover:bg-[#2A1408]/10"
                                    }`
                                }
                                style={{ fontFamily: "Bricolage Grotesque, sans-serif" }}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/contact"
                            className="ml-3 brand-btn text-sm py-2"
                            data-testid="nav-cta-contact"
                        >
                            Nous contacter →
                        </Link>
                    </nav>

                    <button
                        type="button"
                        aria-label="Menu"
                        onClick={() => setOpen(!open)}
                        className="md:hidden text-[#2A1408]"
                        data-testid="navbar-burger"
                    >
                        {open ? <X size={28} /> : <Menu size={28} />}
                    </button>
                </div>

                {open && (
                    <div className="md:hidden bg-[#FFF1E0] border-t-2 border-[#2A1408]">
                        <div className="flex flex-col px-6 py-4 gap-2">
                            {links.map((l) => (
                                <NavLink
                                    key={l.to}
                                    to={l.to}
                                    data-testid={`nav-mobile-${l.to.replace("/", "") || "home"}`}
                                    onClick={() => setOpen(false)}
                                    className={({ isActive }) =>
                                        `text-base font-bold px-3 py-2 rounded-md ${
                                            isActive
                                                ? "bg-[#2A1408] text-[#FFF1E0]"
                                                : "text-[#2A1408]"
                                        }`
                                    }
                                    style={{ fontFamily: "Bricolage Grotesque, sans-serif" }}
                                >
                                    {l.label}
                                </NavLink>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
}
